<script setup lang="ts" generic="T">
import type { Color } from 'nuxt-base/components/UiColorBubble.vue'

const t2 = useT2({
  Activity: 'Istorija',
  'No activity': 'Nėra istorijos',
})
const props = defineProps<{
  nolabel?: boolean
  price?: boolean
  history: T[] | None
  ui(i: T): None | { at: string | Date; label: stringI18n | undefined; color: Color | undefined }
  filterStatusByDate?: Date | None
}>()

const ui = computed(() => {
  const items = helpers
    .arr(helpers.arr(props.history), (item2) => {
      const item = props.ui(item2)
      if (!item) return
      const at = helpers.toDate(item.at)
      if (!at || !item.label) return
      return {
        time: at.getTime(),
        label: item.label,
        color: item.color,
        at,
        uiDate: helpers.uiDate(at, 'y:m:d h:m'),
      }
    })
    .sort((a, b) => a.time - b.time)

  const filter = props.filterStatusByDate

  const getNow = () => {
    if (!filter) return items.at(-1)
    return items.filter((i) => i.at < filter).at(-1)
  }
  return { items, now: getNow() }
})
</script>

<template>
  <div v-if="history?.length" class="m_pt2 m_pb1 m_pl1 m_pr1">
    <h4 v-if="!nolabel" class="_pb1 d_pl14">{{ t2('Activity') }}</h4>

    <div v-for="item in ui.items" :key="item.time" class="_row _ctrY _wm70ch d_pl14 _fw-l _start" :class="[item.at === ui.now?.at ? '_fs1 _c1 _hm34' : '_hm28 _fs09 _c4 m_hm28 d_hm20']">
      <span class="_ls-xs _mr2 _fs09">{{ item.uiDate }}</span>
      <UiColorBubble v-if="item?.color" :color="item?.color" class="_mr06" />
      <b v-if="price" class="_mono">{{ item?.label }}</b>
      <span v-else class="_label">{{ item?.label }}</span>
    </div>
  </div>

  <div v-else-if="!history?.length" class="_italic d_pl14">{{ t2('No activity') }}</div>
</template>
